import { Segmentation, SegmentationData } from 'constants/segmentation';

/**
 * Get segmentation from collection path: finds "collections" in the path, if it exist takes next segment and try to find
 * it in SegmentationData.
 * It works only with relative url (path), it does not work with absolute one
 */
export const getSegmentationFromUrl = ({ path }: { path: string }): Segmentation | undefined => {
  const trimmedUrl = path.replace(/(\/collections\/[^/]+)\/.*$/, '$1').trim();
  return SegmentationData.segmentation.find(
    // It needs to remove the filters in the url, in case these are present
    (seg) => seg.redirectPages.includes(trimmedUrl)
  );
};
